var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetTypeImage = function SvgAssetTypeImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 17v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2zm2.963-2.294-3.339-3.71a1.5 1.5 0 0 0-2.236.007l-1.627 1.83a1.95 1.95 0 0 1-2.63.266.95.95 0 0 0-1.19.038l-2.79 2.392A1 1 0 0 0 8 16h12a1 1 0 0 0 1-1v-.327zM17 17v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2v7a2 2 0 0 0 2 2zm4-3.747V6a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v8.341l2.29-1.963a1.95 1.95 0 0 1 2.442-.08.95.95 0 0 0 1.282-.128l1.627-1.83a2.5 2.5 0 0 1 3.726-.012z",
    clipRule: "evenodd"
  })));
};
export default SvgAssetTypeImage;